import React, { useRef, useState } from "react";
import { Tooltip, IconButton } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { StyledMenu, StyledMenuItem, StyledIconButton, StyledMeatballsButton } from "./MeatballsMenuStyles";
import PropTypes from "prop-types";
import themeCreator from "@Themes/themeCreator";

export default function MeatballsMenu({ options }) {
  const theme = themeCreator();
  const anchorRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen((prevOpen) => !prevOpen);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <StyledMeatballsButton ref={anchorRef} aria-label="Actions" color="blue" onClick={handleClick}>
        <MoreHorizIcon />
      </StyledMeatballsButton>
      <StyledMenu
        anchorEl={anchorRef.current}
        open={isOpen}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
      >
        {options.map((option, index) => (
          <StyledMenuItem
            key={index}
            onClick={() => {
                if(option.action){
                    option.action();
                    handleClose();
                }
            }}
            disabled={option.disabled}
          >
            <Tooltip title={option.label}>
              <StyledIconButton
                color={option.color}
                disabled={option.disabled}
                aria-label={option.label}
              >
                {option.icon}
              </StyledIconButton>
            </Tooltip>
          </StyledMenuItem>
        ))}
      </StyledMenu>
    </>
  );
}

MeatballsMenu.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.node.isRequired,
      color: PropTypes.string.isRequired,
      action: PropTypes.func.isRequired,
      disabled: PropTypes.bool,
    })
  ).isRequired,
};
